import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import {
    fetchProducts,
    selectProducts,
} from '../features/store/products/product.slice';

const useProducts = () => {
    const dispatch = useAppDispatch();
    const products = useAppSelector(selectProducts);

    const getProducts = async () => {
        await dispatch(fetchProducts());
    };

    useEffect(() => {
        if (products.length === 0) {
            getProducts();
        }
    }, []);

    return [products];
};

export default useProducts;
